import { render, staticRenderFns } from "./create-company.vue?vue&type=template&id=7551e5ac&"
import script from "./create-company.vue?vue&type=script&lang=ts&"
export * from "./create-company.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports